<!-- Modals -->
<app-deprecated-modal-form
    #createModal
    thin="true"
    [form]="documentForm"
    headerText="employees.documents.viewOnlyDocument"
    (save)="onCreate(documentForm)"
    label="Create"
>
    <app-employee-document-form #documentForm [isSelfUpload]="viewingSelf" [roles]="roles"></app-employee-document-form>
</app-deprecated-modal-form>

<ui-confirmation-dialog
    header="employees.documents.deleteDocument"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p *ngIf="isIncompleteSignatureRequest">{{ 'document.isIncompleteSignatureRequest' | translate }}</p>
    <p>{{ 'employees.documents.thisActionCannotBeUndone' | translate }}</p>
</ui-confirmation-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event">
        <div class="buttons">
            <ui-button *ngIf="canCreateDocument" (click)="addDocument()" type="primary">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'employees.documents.document' | translate }}
            </ui-button>
        </div>
    </app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="content">
            <app-table [table]="table" (menuItemSelected)="onTableMenuEvent($event)">
                <!-- Empty -->
                <div class="empty">
                    <img src="/assets/illustrations/documents.png" />
                    <h2 class="ui centered header">
                        {{ 'employees.documents.thisEmployeeDoesntHaveAnyDocuments' | translate }}
                        <div
                            class="sub header"
                            [innerHTML]="'employees.documents.newDocumentsCanBeCreatedIn' | translate"
                        ></div>
                    </h2>
                </div>
            </app-table>
        </div>
    </div>
</div>
